import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.parse-float.js";
import axios from "axios";
import dayjs from "dayjs";
import { useCurrency } from "@/composables/useCurrency";
import client from "@/utils/axios";
import { numbro } from "@/utils/filters";
import { formatSpotBalanceResponse } from "@/utils/formatters";
import { findIndexInArray, formatCurrencyCasing, getAssetToBalanceMap, getAssetToPositiveBalanceMap, getRoundedDownValue } from "@/utils/helpers";
import { add, isGreaterThanOrEqualTo, isLessThan, isZero } from "@/utils/math";
import agreements from "@/store/modules/agreements";
import apiKeys from "@/store/modules/apiKeys";
import auth from "@/store/modules/auth";
import config from "@/store/modules/config";
import customerApiKeys from "@/store/modules/customerApiKeys";
import defi from "@/store/modules/defi";
import detelio from "@/store/modules/detelio";
import earn from "@/store/modules/earn";
import fees from "@/store/modules/fees";
import loans from "@/store/modules/loans";
import newPortfolio from "@/store/modules/new-portfolio";
import notifications from "@/store/modules/notifications";
import openOrdersAndPositions from "@/store/modules/openOrdersAndPositions";
import pnl from "@/store/modules/pnl";
import portfolio from "@/store/modules/portfolio";
import reports from "@/store/modules/reports";
import risk from "@/store/modules/risk";
import riskquant from "@/store/modules/riskquant";
import trades from "@/store/modules/trades";
import trading from "@/store/modules/trading";
import transactions from "@/store/modules/transactions";
import transfer from "@/store/modules/transfer";
import whitelist from "@/store/modules/whitelist";
import withdraw from "@/store/modules/withdraw";
import { STATISTICS_PERIOD, STATISTICS_PERIOD_UNIT, TETHER_CHAINS_CURRENCIES, ZERO_CONVERTED_BALANCES } from "@/constants";
import { CURRENCIES } from "@/constants/currencies";
var USDTs = new Set(["USDT_OMNI", "USDT_ERC20", "USDT_TRC20"]);
var balanceHistoryCancelTokenSource;
var spotBalanceCancelTokenSource;
var pnlHistoryRealisedCancelTokenSource;
var pnlHistoryUnrealisedCancelTokenSource;
function getTodayBalance(data) {
  return data.reduce(function (acc, val) {
    if (!val.defiExchange && !val.virtualExchange) {
      for (var key in val.totalConverted) {
        var value = val.totalConverted[key];
        acc[key] = add(acc[key], value);
      }
    }
    return acc;
  }, {
    BTC: 0,
    ETH: 0,
    USDT: 0
  });
}
function getCurrencyTodayBalance(data, currencies) {
  var currenciesArr = Array.isArray(currencies) ? currencies : [currencies];
  return currenciesArr.reduce(function (memo, currency) {
    return data.reduce(function (acc, _ref) {
      var balance = _ref.balance;
      memo[currency] = add(acc[currency], balance[currency]);
      return memo;
    }, _defineProperty({}, currency, 0));
  }, {});
}
function getDateRangeStart() {
  var period = config.state.activeDateRange;
  switch (period === null || period === void 0 ? void 0 : period.toLowerCase()) {
    case '1w':
      return dayjs().utc().subtract(1, 'week').format(config.state.uiFormatters.DATE_FORMAT);
    case '2w':
      return dayjs().utc().subtract(2, 'week').format(config.state.uiFormatters.DATE_FORMAT);
    case '1m':
      return dayjs().utc().subtract(1, 'month').format(config.state.uiFormatters.DATE_FORMAT);
    case '3m':
      return dayjs().utc().subtract(3, 'month').format(config.state.uiFormatters.DATE_FORMAT);
    case '1y':
      return dayjs().utc().subtract(1, 'year').format(config.state.uiFormatters.DATE_FORMAT);
    case 'ytd':
    case 'all':
      return dayjs().startOf('year').format(config.state.uiFormatters.DATE_FORMAT);
    default:
      return null;
  }
}
var getDefaultState = function getDefaultState() {
  return {
    balanceHistory: {},
    isBalanceHistoryLoading: false,
    spotBalance: [],
    isSpotBalanceLoading: false,
    rawSpotBalance: [],
    totalBalance: {},
    derivativesTotalBalance: {},
    derivatives: {},
    isDerivativeBalanceLoading: false,
    derivativesCollateral: [],
    portfolioParams: {},
    pnlHistoryRealised24h: {},
    pnlHistoryRealised: {},
    pnlHistoryUnrealised: {},
    route: null,
    isRestricted: false
  };
};
var state = getDefaultState();
var actions = {
  resetStore: function resetStore(_ref2) {
    var commit = _ref2.commit;
    commit("resetStore");
  },
  loadPNLHistoryRealised24h: function loadPNLHistoryRealised24h(_ref3) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var commit, getters, _yield$client$get, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref3.commit, getters = _ref3.getters;
            _context.prev = 1;
            _context.next = 4;
            return client.get("/api/pnl/history", {
              params: {
                startDate: getters.yesterdayDate,
                endDate: getters.todayDate,
                types: ['spot', 'margin', 'custody', 'collateral']
              }
            });
          case 4:
            _yield$client$get = _context.sent;
            data = _yield$client$get.data;
            commit("setPNLHistoryRealised24h", data);
            _context.next = 11;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 9]]);
    }))();
  },
  loadPNLHistoryRealised: function loadPNLHistoryRealised(_ref4, period) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var commit, _yield$client$get2, data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref4.commit;
            if (pnlHistoryRealisedCancelTokenSource) {
              pnlHistoryRealisedCancelTokenSource.cancel();
            }
            pnlHistoryRealisedCancelTokenSource = axios.CancelToken.source();
            _context2.prev = 3;
            _context2.next = 6;
            return client.get("/api/pnl/history", {
              params: {
                startDate: period ? dayjs(period.start).format(config.state.uiFormatters.DATE_FORMAT) : getDateRangeStart(),
                endDate: period ? dayjs(period.end).format(config.state.uiFormatters.DATE_FORMAT) : dayjs().utc().format(config.state.uiFormatters.DATE_FORMAT),
                types: ['spot', 'margin', 'custody', 'collateral']
              },
              cancelToken: pnlHistoryRealisedCancelTokenSource.token
            });
          case 6:
            _yield$client$get2 = _context2.sent;
            data = _yield$client$get2.data;
            commit("setPNLHistoryRealised", data);
            _context2.next = 13;
            break;
          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](3);
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[3, 11]]);
    }))();
  },
  loadPNLHistoryUnrealised: function loadPNLHistoryUnrealised(_ref5, period) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var commit, _yield$client$get3, data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            commit = _ref5.commit;
            if (pnlHistoryUnrealisedCancelTokenSource) {
              pnlHistoryUnrealisedCancelTokenSource.cancel();
            }
            pnlHistoryUnrealisedCancelTokenSource = axios.CancelToken.source();
            _context3.prev = 3;
            _context3.next = 6;
            return client.get("/api/pnl/history", {
              params: {
                startDate: period ? dayjs(period.start).format(config.state.uiFormatters.DATE_FORMAT) : getDateRangeStart(),
                endDate: period ? dayjs(period.end).format(config.state.uiFormatters.DATE_FORMAT) : dayjs().utc().format(config.state.uiFormatters.DATE_FORMAT),
                types: ['positionUnrealized']
              },
              cancelToken: pnlHistoryUnrealisedCancelTokenSource.token
            });
          case 6:
            _yield$client$get3 = _context3.sent;
            data = _yield$client$get3.data;
            commit("setPNLHistoryUnrealised", data);
            _context3.next = 13;
            break;
          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](3);
          case 13:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[3, 11]]);
    }))();
  },
  fetchDerivatives: function fetchDerivatives(_ref6) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var commit, _yield$client$get4, data;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            commit = _ref6.commit;
            _context4.prev = 1;
            _context4.next = 4;
            return client.get("/api/my/derivatives");
          case 4:
            _yield$client$get4 = _context4.sent;
            data = _yield$client$get4.data;
            commit("setDerivatives", data);
            _context4.next = 12;
            break;
          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](1);
            commit("setDerivatives", {});
          case 12:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[1, 9]]);
    }))();
  },
  loadDerivativesCollateral: function loadDerivativesCollateral(_ref7) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var state, commit, isDerivativeBalanceLoading, _yield$client$get5, data;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            state = _ref7.state, commit = _ref7.commit;
            isDerivativeBalanceLoading = state.isDerivativeBalanceLoading;
            if (!isDerivativeBalanceLoading) {
              _context5.next = 4;
              break;
            }
            return _context5.abrupt("return");
          case 4:
            commit("setIsDerivativeBalanceLoading", true);
            _context5.prev = 5;
            _context5.next = 8;
            return client.get("/api/v2/my/balance/derivatives");
          case 8:
            _yield$client$get5 = _context5.sent;
            data = _yield$client$get5.data;
            commit("setDerivativesCollateral", (data === null || data === void 0 ? void 0 : data.balances) || []);
            commit("setDerivativesTotalBalance", data === null || data === void 0 ? void 0 : data.totalConverted);
            _context5.next = 17;
            break;
          case 14:
            _context5.prev = 14;
            _context5.t0 = _context5["catch"](5);
            commit("setDerivativesCollateral", []);
          case 17:
            _context5.prev = 17;
            commit("setIsDerivativeBalanceLoading", false);
            return _context5.finish(17);
          case 20:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[5, 14, 17, 20]]);
    }))();
  },
  updateCurrentBalance: function updateCurrentBalance(_ref8, apiKeyToLastBalanceMap) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var _state$route, _state$route2;
      var state, getters, commit, balanceHistory, portfolioParams, getFormattedBalanceHistory, dates, todayKey, updatedFormattedBalances, updatedRawBalances, todayBalance, isFilledParams, _portfolioParams$apiK2, _portfolioParams$curr2, filteredBalance;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            state = _ref8.state, getters = _ref8.getters, commit = _ref8.commit;
            if (!(((_state$route = state.route) === null || _state$route === void 0 ? void 0 : _state$route.name) === "portfolio" || ((_state$route2 = state.route) === null || _state$route2 === void 0 ? void 0 : _state$route2.name) === "dashboard")) {
              _context6.next = 3;
              break;
            }
            return _context6.abrupt("return");
          case 3:
            balanceHistory = state.balanceHistory, portfolioParams = state.portfolioParams;
            getFormattedBalanceHistory = getters.getFormattedBalanceHistory;
            dates = Object.keys(balanceHistory);
            todayKey = dates[dates.length - 1];
            updatedFormattedBalances = getFormattedBalanceHistory(apiKeyToLastBalanceMap);
            updatedRawBalances = getFormattedBalanceHistory(apiKeyToLastBalanceMap, true);
            if (updatedRawBalances) {
              commit("setRawSpotBalance", updatedRawBalances);
            }
            if (updatedFormattedBalances) {
              _context6.next = 12;
              break;
            }
            return _context6.abrupt("return");
          case 12:
            todayBalance = getTodayBalance(updatedFormattedBalances);
            commit("setSpotBalance", updatedFormattedBalances);
            commit("setTotalBalance", todayBalance);
            isFilledParams = Object.values(portfolioParams).some(function (value) {
              if (Array.isArray(value)) {
                return value.length > 0;
              }
              return value !== null;
            });
            if (isFilledParams) {
              filteredBalance = state.spotBalance.filter(function (_ref9) {
                var _portfolioParams$exch;
                var balance = _ref9.balance,
                  exchangeId = _ref9.exchangeId,
                  apiKeyId = _ref9.apiKeyId;
                if (portfolioParams.apiKeyIds) {
                  var _portfolioParams$apiK;
                  return (_portfolioParams$apiK = portfolioParams.apiKeyIds) === null || _portfolioParams$apiK === void 0 ? void 0 : _portfolioParams$apiK.includes(apiKeyId);
                }
                if (portfolioParams.currencies) {
                  var _Object$keys$filter;
                  return ((_Object$keys$filter = Object.keys(balance).filter(function (currency) {
                    var _portfolioParams$curr;
                    return (_portfolioParams$curr = portfolioParams.currencies) === null || _portfolioParams$curr === void 0 ? void 0 : _portfolioParams$curr.includes(currency);
                  })) === null || _Object$keys$filter === void 0 ? void 0 : _Object$keys$filter.length) > 0;
                }
                return (_portfolioParams$exch = portfolioParams.exchangeIds) === null || _portfolioParams$exch === void 0 ? void 0 : _portfolioParams$exch.includes(exchangeId);
              });
              if (((_portfolioParams$apiK2 = portfolioParams.apiKeyIds) === null || _portfolioParams$apiK2 === void 0 ? void 0 : _portfolioParams$apiK2.length) > 0) {
                todayBalance = getCurrencyTodayBalance(filteredBalance, portfolioParams.accountCurrency);
              } else if (((_portfolioParams$curr2 = portfolioParams.currencies) === null || _portfolioParams$curr2 === void 0 ? void 0 : _portfolioParams$curr2.length) > 0) {
                todayBalance = getCurrencyTodayBalance(filteredBalance, portfolioParams.currencies);
              } else {
                todayBalance = getTodayBalance(filteredBalance);
              }
            }
            balanceHistory[todayKey] = todayBalance;
            commit("setBalanceHistory", balanceHistory);
          case 19:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  },
  getFiatReference: function getFiatReference() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", client.get("/api/wallet/external/id"));
          case 1:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }))();
  },
  loadBalanceHistory: function loadBalanceHistory(_ref10) {
    var _arguments = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      var state, commit, parameters, isBalancehistoryLoading, portfolioParams, params, endpoint, _yield$client$get6, data;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            state = _ref10.state, commit = _ref10.commit;
            parameters = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {};
            isBalancehistoryLoading = state.isBalancehistoryLoading, portfolioParams = state.portfolioParams;
            if (!isBalancehistoryLoading) {
              _context8.next = 5;
              break;
            }
            return _context8.abrupt("return");
          case 5:
            commit("setIsBalanceHistoryLoading", true);
            if (balanceHistoryCancelTokenSource) {
              balanceHistoryCancelTokenSource.cancel();
            }
            balanceHistoryCancelTokenSource = axios.CancelToken.source();
            params = Object.keys(parameters).length && portfolioParams.apiKeyIds === null ? _objectSpread({
              period: config.state.activeDateRange
            }, parameters) : _objectSpread(_objectSpread({
              period: config.state.activeDateRange
            }, portfolioParams), {}, {
              currencies: Array.isArray(portfolioParams.accountCurrency) ? portfolioParams.accountCurrency : [portfolioParams.accountCurrency]
            });
            endpoint = params.total ? "total" : "total-converted";
            _context8.prev = 10;
            _context8.next = 13;
            return client.get("/api/my/balance-history/".concat(endpoint), {
              params: params,
              cancelToken: balanceHistoryCancelTokenSource.token
            });
          case 13:
            _yield$client$get6 = _context8.sent;
            data = _yield$client$get6.data;
            commit("setBalanceHistory", data);
            _context8.next = 22;
            break;
          case 18:
            _context8.prev = 18;
            _context8.t0 = _context8["catch"](10);
            if (!axios.isCancel(_context8.t0)) {
              _context8.next = 22;
              break;
            }
            return _context8.abrupt("return");
          case 22:
            _context8.prev = 22;
            commit("setIsBalanceHistoryLoading", false);
            return _context8.finish(22);
          case 25:
          case "end":
            return _context8.stop();
        }
      }, _callee8, null, [[10, 18, 22, 25]]);
    }))();
  },
  getVirtualBalances: function getVirtualBalances(_ref11) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
      var _config$state$transfe, _portfolio$state$acti;
      var commit, dispatch, rootGetters, BALANCE_CONVERTED_DEFAULT, balanceVirtual;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            commit = _ref11.commit, dispatch = _ref11.dispatch, rootGetters = _ref11.rootGetters;
            if (!rootGetters["defi/defiAvailable"]) {
              _context9.next = 6;
              break;
            }
            _context9.next = 4;
            return dispatch("defi/updateBalance");
          case 4:
            _context9.next = 8;
            break;
          case 6:
            commit("defi/setBalanceSpot", null);
            commit("defi/setBalances", []);
          case 8:
            BALANCE_CONVERTED_DEFAULT = {
              BTC: "0",
              ETH: "0",
              USDT: "0"
            };
            balanceVirtual = (_config$state$transfe = config.state.transferCurrencies) === null || _config$state$transfe === void 0 ? void 0 : _config$state$transfe.reduce(function (memo, val) {
              memo.balance[val.instrument] = "0";
              memo.balanceConverted[val.instrument] = BALANCE_CONVERTED_DEFAULT;
              memo.funding[val.instrument] = "0";
              memo.fundingConverted[val.instrument] = BALANCE_CONVERTED_DEFAULT;
              return memo;
            }, {
              balance: {},
              balanceConverted: {},
              funding: {},
              fundingConverted: {},
              totalConverted: BALANCE_CONVERTED_DEFAULT
            });
            return _context9.abrupt("return", (_portfolio$state$acti = portfolio.state.activePortfolio.ApiKeys) === null || _portfolio$state$acti === void 0 ? void 0 : _portfolio$state$acti.reduce(function (memo, current) {
              if (!config.state.virtualExchanges.includes(current.exchangeId) || !current.active) {
                return memo;
              }
              var result = {
                apiKeyId: current.id,
                available: balanceVirtual.balance,
                availableConverted: balanceVirtual.balanceConverted,
                balance: balanceVirtual.balance,
                balanceConverted: balanceVirtual.balanceConverted,
                funding: balanceVirtual.funding,
                fundingConverted: balanceVirtual.fundingConverted,
                totalConverted: balanceVirtual.totalConverted,
                virtualExchange: true
              };
              if (current.exchangeId === "fireblocks" && current.active) {
                var convertedAdd = function convertedAdd(sum, to) {
                  if (!to) {
                    return sum;
                  }
                  return {
                    BTC: add(sum.BTC, to.BTC),
                    ETH: add(sum.ETH, to.ETH),
                    USDT: add(sum.USDT, to.USDT)
                  };
                };
                var balanceAccount = defi.state.balances.reduce(function (acc, val) {
                  var _val$tokenInfo, _val$tokenInfo2;
                  var alias = val.tokenInfo.alias;
                  var isValid = (val === null || val === void 0 || (_val$tokenInfo = val.tokenInfo) === null || _val$tokenInfo === void 0 || (_val$tokenInfo = _val$tokenInfo.assetTypeMeta) === null || _val$tokenInfo === void 0 ? void 0 : _val$tokenInfo.side) === 1 && (val === null || val === void 0 || (_val$tokenInfo2 = val.tokenInfo) === null || _val$tokenInfo2 === void 0 || (_val$tokenInfo2 = _val$tokenInfo2.assetTypeMeta) === null || _val$tokenInfo2 === void 0 ? void 0 : _val$tokenInfo2.protocol) === null;
                  if (alias && isValid) {
                    acc.balance[alias] = val.available;
                    acc.balanceConverted[alias] = val.availableConverted;
                    acc.totalConverted = convertedAdd(acc.totalConverted, val.totalConverted);
                  }
                  return acc;
                }, {
                  available: {},
                  availableConverted: {},
                  balance: {},
                  balanceConverted: {},
                  totalConverted: BALANCE_CONVERTED_DEFAULT
                });
                result = {
                  apiKeyId: current.id,
                  available: balanceAccount.balance,
                  availableConverted: balanceAccount.balanceConverted,
                  balance: balanceAccount.balance,
                  balanceConverted: balanceAccount.balanceConverted,
                  totalConverted: balanceAccount.totalConverted,
                  defiExchange: true
                };
              }
              memo.push(result);
              return memo;
            }, []));
          case 11:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }))();
  },
  loadSpotBalance: function loadSpotBalance(_ref12) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
      var commit, state, dispatch, isSpotBalanceLoading, _yield$Promise$all, _yield$Promise$all2, data, balancesVirtual, balances, formattedData;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            commit = _ref12.commit, state = _ref12.state, dispatch = _ref12.dispatch;
            isSpotBalanceLoading = state.isSpotBalanceLoading;
            if (!isSpotBalanceLoading) {
              _context10.next = 4;
              break;
            }
            return _context10.abrupt("return");
          case 4:
            commit("setIsSpotBalanceLoading", true);
            if (spotBalanceCancelTokenSource) {
              spotBalanceCancelTokenSource.cancel();
            }
            spotBalanceCancelTokenSource = axios.CancelToken.source();
            _context10.prev = 7;
            _context10.next = 10;
            return Promise.all([client.get("/api/my/balance/spot", {
              cancelToken: spotBalanceCancelTokenSource.token
            }), dispatch("getVirtualBalances")]);
          case 10:
            _yield$Promise$all = _context10.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            data = _yield$Promise$all2[0].data;
            balancesVirtual = _yield$Promise$all2[1];
            balances = data.balances.concat(balancesVirtual);
            commit("setRawSpotBalance", balances);
            formattedData = formatSpotBalanceResponse(balances);
            commit("setSpotBalance", formattedData);
            commit("setTotalBalance", data.totalConverted);
            _context10.next = 24;
            break;
          case 21:
            _context10.prev = 21;
            _context10.t0 = _context10["catch"](7);
            console.log('error', _context10.t0);
            // nothing
          case 24:
            _context10.prev = 24;
            commit("setIsSpotBalanceLoading", false);
            return _context10.finish(24);
          case 27:
          case "end":
            return _context10.stop();
        }
      }, _callee10, null, [[7, 21, 24, 27]]);
    }))();
  },
  removeAggregatedParameter: function removeAggregatedParameter(_ref13, apiKeyToParameterMap) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
      var state, commit, _loop, key;
      return _regeneratorRuntime().wrap(function _callee11$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            state = _ref13.state, commit = _ref13.commit;
            if (state.derivatives.aggregatedParams) {
              _context12.next = 3;
              break;
            }
            return _context12.abrupt("return");
          case 3:
            _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop(key) {
              var index;
              return _regeneratorRuntime().wrap(function _loop$(_context11) {
                while (1) switch (_context11.prev = _context11.next) {
                  case 0:
                    index = findIndexInArray(state.derivatives.aggregatedParams, function (param) {
                      var paramToRemove = apiKeyToParameterMap[param.apiKeyId];
                      return param.apiKeyId === key && paramToRemove.accountType === param.accountType && paramToRemove.currency === param.currency;
                    });
                    if (index > -1) {
                      state.derivatives.aggregatedParams.splice(index, 1);
                    }
                  case 2:
                  case "end":
                    return _context11.stop();
                }
              }, _loop);
            });
            _context12.t0 = _regeneratorRuntime().keys(apiKeyToParameterMap);
          case 5:
            if ((_context12.t1 = _context12.t0()).done) {
              _context12.next = 10;
              break;
            }
            key = _context12.t1.value;
            return _context12.delegateYield(_loop(key), "t2", 8);
          case 8:
            _context12.next = 5;
            break;
          case 10:
            commit("setDerivatives", state.derivatives);
          case 11:
          case "end":
            return _context12.stop();
        }
      }, _callee11);
    }))();
  },
  updateAggregatedParameter: function updateAggregatedParameter(_ref14, apiKeyToParameterMap) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
      var state, commit, _loop2, key;
      return _regeneratorRuntime().wrap(function _callee12$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            state = _ref14.state, commit = _ref14.commit;
            if (state.derivatives.aggregatedParams) {
              _context14.next = 3;
              break;
            }
            return _context14.abrupt("return");
          case 3:
            _loop2 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop2(key) {
              var newParam, index;
              return _regeneratorRuntime().wrap(function _loop2$(_context13) {
                while (1) switch (_context13.prev = _context13.next) {
                  case 0:
                    newParam = {};
                    index = findIndexInArray(state.derivatives.aggregatedParams, function (param) {
                      var paramToUpdate = apiKeyToParameterMap[param.apiKeyId];
                      var isTargetParam = param.apiKeyId === key && paramToUpdate.accountType === param.accountType && paramToUpdate.currency === param.currency;
                      if (isTargetParam) {
                        newParam = paramToUpdate;
                      }
                      return isTargetParam;
                    });
                    if (index > -1) {
                      state.derivatives.aggregatedParams[index] = _objectSpread(_objectSpread({}, state.derivatives.aggregatedParams[index]), newParam);
                    }
                  case 3:
                  case "end":
                    return _context13.stop();
                }
              }, _loop2);
            });
            _context14.t0 = _regeneratorRuntime().keys(apiKeyToParameterMap);
          case 5:
            if ((_context14.t1 = _context14.t0()).done) {
              _context14.next = 10;
              break;
            }
            key = _context14.t1.value;
            return _context14.delegateYield(_loop2(key), "t2", 8);
          case 8:
            _context14.next = 5;
            break;
          case 10:
            commit("setDerivatives", state.derivatives);
          case 11:
          case "end":
            return _context14.stop();
        }
      }, _callee12);
    }))();
  },
  removePosition: function removePosition(_ref15, apiKeyToPositionMap) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
      var state, commit, _loop3, key;
      return _regeneratorRuntime().wrap(function _callee13$(_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            state = _ref15.state, commit = _ref15.commit;
            if (state.derivatives.positions) {
              _context16.next = 3;
              break;
            }
            return _context16.abrupt("return");
          case 3:
            _loop3 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop3(key) {
              var index;
              return _regeneratorRuntime().wrap(function _loop3$(_context15) {
                while (1) switch (_context15.prev = _context15.next) {
                  case 0:
                    index = findIndexInArray(state.derivatives.positions, function (param) {
                      var paramToRemove = apiKeyToPositionMap[param.apiKeyId];
                      return param.apiKeyId === key && paramToRemove.contract === param.contract && paramToRemove.contractType === param.contractType && paramToRemove.positionSide === param.positionSide;
                    });
                    if (index > -1) {
                      state.derivatives.positions.splice(index, 1);
                    }
                  case 2:
                  case "end":
                    return _context15.stop();
                }
              }, _loop3);
            });
            _context16.t0 = _regeneratorRuntime().keys(apiKeyToPositionMap);
          case 5:
            if ((_context16.t1 = _context16.t0()).done) {
              _context16.next = 10;
              break;
            }
            key = _context16.t1.value;
            return _context16.delegateYield(_loop3(key), "t2", 8);
          case 8:
            _context16.next = 5;
            break;
          case 10:
            commit("setDerivatives", state.derivatives);
          case 11:
          case "end":
            return _context16.stop();
        }
      }, _callee13);
    }))();
  },
  updatePosition: function updatePosition(_ref16, apiKeyToPositionMap) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
      var state, commit, _loop4, key;
      return _regeneratorRuntime().wrap(function _callee14$(_context18) {
        while (1) switch (_context18.prev = _context18.next) {
          case 0:
            state = _ref16.state, commit = _ref16.commit;
            if (state.derivatives.positions) {
              _context18.next = 3;
              break;
            }
            return _context18.abrupt("return");
          case 3:
            _loop4 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop4(key) {
              var newPosition, index;
              return _regeneratorRuntime().wrap(function _loop4$(_context17) {
                while (1) switch (_context17.prev = _context17.next) {
                  case 0:
                    newPosition = {};
                    index = findIndexInArray(state.derivatives.positions, function (param) {
                      var positionToUpdate = apiKeyToPositionMap[param.apiKeyId];
                      var isTargetPosition = param.apiKeyId === key && positionToUpdate.contract === param.contract && positionToUpdate.contractType === param.contractType && positionToUpdate.positionSide === param.positionSide;
                      if (isTargetPosition) {
                        newPosition = positionToUpdate;
                      }
                      return isTargetPosition;
                    });
                    if (index > -1) {
                      state.derivatives.positions[index] = _objectSpread(_objectSpread({}, state.derivatives.positions[index]), newPosition);
                    } else if (apiKeyToPositionMap[key]) {
                      state.derivatives.positions.unshift(apiKeyToPositionMap[key]);
                    }
                  case 3:
                  case "end":
                    return _context17.stop();
                }
              }, _loop4);
            });
            _context18.t0 = _regeneratorRuntime().keys(apiKeyToPositionMap);
          case 5:
            if ((_context18.t1 = _context18.t0()).done) {
              _context18.next = 10;
              break;
            }
            key = _context18.t1.value;
            return _context18.delegateYield(_loop4(key), "t2", 8);
          case 8:
            _context18.next = 5;
            break;
          case 10:
            commit("setDerivatives", state.derivatives);
          case 11:
          case "end":
            return _context18.stop();
        }
      }, _callee14);
    }))();
  },
  updateCollateral: function updateCollateral(_ref17, apiKeyToCollateralMap) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
      var state, getters, commit, derivativesCollateralMap, _i, _Object$entries, _Object$entries$_i, item, apiKeyId, currency, accountType, key, itemToUpdate;
      return _regeneratorRuntime().wrap(function _callee15$(_context19) {
        while (1) switch (_context19.prev = _context19.next) {
          case 0:
            state = _ref17.state, getters = _ref17.getters, commit = _ref17.commit;
            if (state.derivativesCollateral) {
              _context19.next = 3;
              break;
            }
            return _context19.abrupt("return");
          case 3:
            derivativesCollateralMap = getters.derivativesCollateralMap;
            for (_i = 0, _Object$entries = Object.entries(apiKeyToCollateralMap); _i < _Object$entries.length; _i++) {
              _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), item = _Object$entries$_i[1];
              apiKeyId = item.apiKeyId, currency = item.currency, accountType = item.accountType;
              key = "".concat(apiKeyId, ":").concat(currency, ":").concat(accountType);
              itemToUpdate = derivativesCollateralMap[key];
              if (itemToUpdate) {
                Object.assign(itemToUpdate, item);
              }
            }
            commit("setDerivativesCollateral", state.derivativesCollateral.slice());
          case 6:
          case "end":
            return _context19.stop();
        }
      }, _callee15);
    }))();
  }
};
var getters = {
  getUserPermissionsSet: function getUserPermissionsSet() {
    return new Set(config.state.userRolePermissions);
  },
  hasPermission: function hasPermission(_, getters) {
    return function (permission) {
      var _getters$getUserPermi;
      return (_getters$getUserPermi = getters.getUserPermissionsSet) === null || _getters$getUserPermi === void 0 ? void 0 : _getters$getUserPermi.has(permission);
    };
  },
  apiKeyIdToPortfolioIdMap: function apiKeyIdToPortfolioIdMap() {
    var _portfolio$state$port;
    if (!auth.state.user) {
      return {};
    }
    var map = {};
    if ((_portfolio$state$port = portfolio.state.portfolios) !== null && _portfolio$state$port !== void 0 && _portfolio$state$port.length) {
      var _iterator = _createForOfIteratorHelper(portfolio.state.portfolios),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _portfolio = _step.value;
          var _iterator2 = _createForOfIteratorHelper(_portfolio.ApiKeys),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var item = _step2.value;
              map[item.id] = _portfolio.id;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return map;
  },
  getApiKeyFromBalanceHistory: function getApiKeyFromBalanceHistory() {
    return function (_ref18) {
      var apiKeyId = _ref18.apiKeyId,
        spotBalance = _ref18.spotBalance;
      if (!spotBalance) {
        return;
      }
      var item = spotBalance.find(function (apiKey) {
        return apiKey.apiKeyId === apiKeyId;
      });
      if (!item) {
        return;
      }
      return item;
    };
  },
  getFormattedBalanceHistory: function getFormattedBalanceHistory(state, getters) {
    return function (apiKeyToLastBalanceMap) {
      var raw = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      for (var apiKeyId in apiKeyToLastBalanceMap) {
        var _apiKeyToLastBalanceM = apiKeyToLastBalanceMap[apiKeyId],
          balance = _apiKeyToLastBalanceM.balance,
          balanceConverted = _apiKeyToLastBalanceM.balanceConverted,
          available = _apiKeyToLastBalanceM.available,
          availableConverted = _apiKeyToLastBalanceM.availableConverted,
          totalConverted = _apiKeyToLastBalanceM.totalConverted;
        var portfolioId = getters.apiKeyIdToPortfolioIdMap[apiKeyId];
        if (portfolio.state.activePortfolioId !== portfolioId) {
          return;
        }
        var apiKey = getters.getApiKeyFromBalanceHistory({
          apiKeyId: apiKeyId,
          spotBalance: state.rawSpotBalance
        });
        if (!apiKey) {
          return;
        }
        apiKey.balance = balance;
        apiKey.balanceConverted = balanceConverted;
        apiKey.available = available;
        apiKey.availableConverted = availableConverted;
        apiKey.totalConverted = totalConverted;
      }
      return raw ? state.rawSpotBalance : formatSpotBalanceResponse(state.rawSpotBalance);
    };
  },
  balance: function balance(state) {
    return state.spotBalance;
  },
  totalBalance: function totalBalance(state) {
    var _useCurrency = useCurrency(),
      convertTo = _useCurrency.convertTo;
    return state.totalBalance[convertTo.value];
  },
  derivativesTotalBalance: function derivativesTotalBalance(state) {
    var _useCurrency2 = useCurrency(),
      convertTo = _useCurrency2.convertTo;
    return state.derivativesTotalBalance[convertTo.value];
  },
  allAccounts: function allAccounts(_, getters) {
    var allAccounts = getters.spotAccountsAvailable.concat(getters.derivativesAccounts);
    allAccounts.sort(function (_ref19, _ref20) {
      var apiKeyName1 = _ref19.apiKeyName,
        exchangeId1 = _ref19.exchangeId;
      var apiKeyName2 = _ref20.apiKeyName,
        exchangeId2 = _ref20.exchangeId;
      var key1 = "".concat(exchangeId1, ":").concat(apiKeyName1);
      var key2 = "".concat(exchangeId2, ":").concat(apiKeyName2);
      return key1.localeCompare(key2);
    });
    return allAccounts;
  },
  derivativesAccountsMap: function derivativesAccountsMap(_, getters) {
    var derivativesAccounts = getters.derivativesAccounts;
    function computeAccountType(exchangeId, accountType) {
      if (exchangeId === "bitfinex" && accountType.includes("margin")) {
        return "margin-cross";
      }
      if (exchangeId === "bitfinex" && accountType.includes("perpetual")) {
        return "perpetual";
      }
      return accountType;
    }
    return derivativesAccounts.reduce(function (memo, item) {
      var exchangeId = item.exchangeId,
        apiKeyId = item.apiKeyId,
        currency = item.currency,
        accountType = item.accountType;
      var computedAccountType = computeAccountType(exchangeId, accountType);
      var key = "".concat(apiKeyId, ":").concat(currency, ":").concat(computedAccountType);
      memo[key] = item;
      return memo;
    }, {});
  },
  aggregatedParamsApiKeyIdAccountTypeMap: function aggregatedParamsApiKeyIdAccountTypeMap(state) {
    var _state$derivatives$ag, _state$derivatives;
    var aggregatedParams = (_state$derivatives$ag = (_state$derivatives = state.derivatives) === null || _state$derivatives === void 0 ? void 0 : _state$derivatives.aggregatedParams) !== null && _state$derivatives$ag !== void 0 ? _state$derivatives$ag : [];
    return aggregatedParams.reduce(function (memo, item) {
      var apiKeyId = item.apiKeyId,
        accountType = item.accountType;
      var key = "".concat(apiKeyId, ":").concat(accountType);
      if (!memo[key]) {
        memo[key] = [];
      }
      memo[key].push(item);
      return memo;
    }, {});
  },
  derivativesAccountsByApiKeyIdMap: function derivativesAccountsByApiKeyIdMap(_, getters) {
    var derivativesAccounts = getters.derivativesAccounts;
    return derivativesAccounts.reduce(function (memo, item) {
      var apiKeyId = item.apiKeyId;
      if (memo[apiKeyId]) {
        memo[apiKeyId].push(item);
      } else {
        memo[apiKeyId] = [item];
      }
      return memo;
    }, {});
  },
  apiKeyIdToDerivativeBalanceMap: function apiKeyIdToDerivativeBalanceMap(_, getters) {
    var derivativesAccountsByApiKeyIdMap = getters.derivativesAccountsByApiKeyIdMap;
    return Object.entries(derivativesAccountsByApiKeyIdMap).reduce(function (memo, _ref21) {
      var _ref22 = _slicedToArray(_ref21, 2),
        apiKeyId = _ref22[0],
        balances = _ref22[1];
      if (balances) {
        memo[apiKeyId] = balances.reduce(function (memo, item) {
          var currency = item.currency,
            balance = item.balance,
            balanceConverted = item.balanceConverted,
            available = item.available,
            availableConverted = item.availableConverted;
          return {
            apiKeyId: apiKeyId,
            currency: currency,
            available: Object.assign(memo.available || {}, available),
            availableConverted: Object.assign(memo.availableConverted || {}, availableConverted),
            balance: Object.assign(memo.balance || {}, balance),
            balanceConverted: Object.assign(memo.balanceConverted || {}, balanceConverted)
          };
        }, {});
      }
      return memo;
    }, {});
  },
  derivativesAccounts: function derivativesAccounts(_, getters) {
    return getters.derivativesCollateralNonZero;
  },
  spotAccounts: function spotAccounts(_, getters, __, rootGetters) {
    if (!getters.balance) {
      return [];
    }
    var _useCurrency3 = useCurrency(),
      convertTo = _useCurrency3.convertTo;
    var getApiKey = rootGetters["portfolio/getApiKey"];
    var getMappedAccountType = getters.getMappedAccountType;
    var getCurrencyFullName = getters.getCurrencyFullName;
    var emptyConverted = Object.assign({}, ZERO_CONVERTED_BALANCES);
    return getters.balance.reduce(function (memo, item) {
      var _getApiKey;
      var _ref23 = (_getApiKey = getApiKey(item.apiKeyId)) !== null && _getApiKey !== void 0 ? _getApiKey : {},
        apiKeyName = _ref23.name,
        bankAccount = _ref23.bankAccount,
        exchangeId = _ref23.exchangeId;
      for (var currency in item.balance) {
        var total = item.balance[currency];
        if (total) {
          var data = {
            item: item,
            exchangeId: exchangeId,
            exchangeFullName: item.exchangeFullName,
            apiKeyId: item.apiKeyId,
            apiKeyName: apiKeyName,
            virtualExchange: item.virtualExchange,
            currency: currency,
            currencyFullName: getCurrencyFullName(currency),
            accountType: "spot",
            formattedAccountType: getMappedAccountType(exchangeId, "spot"),
            total: +total,
            totalConverted: item.balanceConverted[currency][convertTo.value],
            bankAccount: bankAccount,
            balance: _defineProperty({}, currency, item.balance[currency] || "0"),
            balanceConverted: _defineProperty({}, currency, item.balanceConverted[currency] || emptyConverted),
            available: _defineProperty({}, currency, item.available[currency] || "0"),
            availableConverted: _defineProperty({}, currency, item.availableConverted[currency] || emptyConverted),
            funding: _defineProperty({}, currency, item.funding[currency] || "0"),
            fundingConverted: _defineProperty({}, currency, item.fundingConverted[currency] || emptyConverted)
          };
          memo.push(data);
        }
      }
      return memo;
    }, []).sort(function (_ref24, _ref25) {
      var apiKeyName1 = _ref24.apiKeyName,
        exchangeId1 = _ref24.exchangeId;
      var apiKeyName2 = _ref25.apiKeyName,
        exchangeId2 = _ref25.exchangeId;
      var key1 = "".concat(exchangeId1, ":").concat(apiKeyName1);
      var key2 = "".concat(exchangeId2, ":").concat(apiKeyName2);
      return key1.localeCompare(key2);
    });
  },
  spotAccountsNonZero: function spotAccountsNonZero(_, getters) {
    var spotAccounts = getters.spotAccounts;
    return spotAccounts.filter(function (_ref26) {
      var currency = _ref26.currency,
        balance = _ref26.balance,
        available = _ref26.available;
      return !isZero(balance[currency]) || !isZero(available[currency]);
    });
  },
  spotAccountsAvailable: function spotAccountsAvailable(_, getters, rootState, rootGetters) {
    if (!getters.balance) {
      return [];
    }
    var getApiKey = rootGetters["portfolio/getApiKey"];
    var _useCurrency4 = useCurrency(),
      convertTo = _useCurrency4.convertTo;
    return getters.balance.reduce(function (memo, item) {
      var _getApiKey2;
      var _ref27 = (_getApiKey2 = getApiKey(item.apiKeyId)) !== null && _getApiKey2 !== void 0 ? _getApiKey2 : {},
        apiKeyName = _ref27.name,
        bankAccount = _ref27.bankAccount,
        exchangeId = _ref27.exchangeId;
      var finalBalance = exchangeId === "binance_custody" ? item.balance : item.available;
      var finalBalanceConverted = exchangeId === "binance_custody" ? item.balanceConverted : item.availableConverted;
      for (var asset in finalBalance) {
        var total = finalBalance[asset];
        if (total) {
          var data = _objectSpread(_objectSpread({}, item), {}, {
            currency: asset,
            accountType: "spot",
            apiKeyName: apiKeyName,
            total: +total,
            totalConverted: finalBalanceConverted[asset][convertTo.value],
            bankAccount: bankAccount
          });
          memo.push(data);
        }
      }
      return memo;
    }, []).sort(function (_ref28, _ref29) {
      var apiKeyName1 = _ref28.apiKeyName,
        exchangeId1 = _ref28.exchangeId;
      var apiKeyName2 = _ref29.apiKeyName,
        exchangeId2 = _ref29.exchangeId;
      var key1 = "".concat(exchangeId1, ":").concat(apiKeyName1);
      var key2 = "".concat(exchangeId2, ":").concat(apiKeyName2);
      return key1.localeCompare(key2);
    });
  },
  bankAccounts: function bankAccounts(state, getters) {
    var _portfolio$state$acti2;
    if (!portfolio.state.activePortfolio) {
      return [];
    }
    var getApiKeyFromBalanceHistory = getters.getApiKeyFromBalanceHistory,
      apiKeyIdToDerivativeBalanceMap = getters.apiKeyIdToDerivativeBalanceMap,
      getExchangeFullName = getters.getExchangeFullName,
      exchangeNames = getters.exchangeNames;
    var bankAccountsExchangeIdsSet = new Set(config.state.bankAccountExchanges);
    return (_portfolio$state$acti2 = portfolio.state.activePortfolio.ApiKeys) === null || _portfolio$state$acti2 === void 0 ? void 0 : _portfolio$state$acti2.reduce(function (memo, current) {
      if (current.bankAccount && current.active && bankAccountsExchangeIdsSet.has(current.exchangeId)) {
        var accountBalance = function (_getApiKeyFromBalance) {
          if (current.exchangeId === exchangeNames.BYBIT) {
            var _apiKeyIdToDerivative;
            return ((_apiKeyIdToDerivative = apiKeyIdToDerivativeBalanceMap[current.id]) === null || _apiKeyIdToDerivative === void 0 ? void 0 : _apiKeyIdToDerivative.available) || {};
          }
          return ((_getApiKeyFromBalance = getApiKeyFromBalanceHistory({
            spotBalance: state.rawSpotBalance,
            apiKeyId: current.id
          })) === null || _getApiKeyFromBalance === void 0 ? void 0 : _getApiKeyFromBalance.available) || {};
        }();
        var exchangeName = getExchangeFullName(current.exchangeId);
        memo.push({
          exchangeId: current.exchangeId,
          name: current.name,
          apiKeyId: current.id,
          exchangeName: exchangeName,
          accountBalance: accountBalance,
          searchBy: ["name"]
        });
      }
      return memo;
    }, []);
  },
  combinedWithdrawCurrencies: function combinedWithdrawCurrencies(_, getters) {
    return function (exchangeId, bankAccount) {
      var exchangeNames = getters.exchangeNames;
      if (!exchangeId || !config.state.withdrawCurrencies[exchangeId]) {
        return [];
      }
      var result = config.state.withdrawCurrencies[exchangeId].map(function (currency) {
        var _ref30, _bankAccount$accountB;
        var balance = (_ref30 = (_bankAccount$accountB = bankAccount.accountBalance[currency.originalName]) !== null && _bankAccount$accountB !== void 0 ? _bankAccount$accountB : bankAccount.accountBalance[currency.displayName]) !== null && _ref30 !== void 0 ? _ref30 : 0;
        var fullCurrency = config.state.currencies.find(function (_ref31) {
          var name = _ref31.name;
          return name === currency.originalName;
        });
        var paymentId = currency.paymentId;
        if ([exchangeNames.FIREBLOCKS, exchangeNames.BYBIT].includes(exchangeId)) {
          var bequantCurrency = config.state.withdrawCurrencies.bequant.find(function (item) {
            return item.originalName === currency.originalName || item.originalName === currency.displayName;
          });
          paymentId = !!(bequantCurrency !== null && bequantCurrency !== void 0 && bequantCurrency.paymentId);
        }
        return _objectSpread(_objectSpread({}, currency), {}, {
          value: currency.originalName,
          text: currency.originalName === "TRX_USDT_S2UZ" ? currency.displayName : currency.originalName,
          displayText: fullCurrency ? fullCurrency.fullName : currency.displayName,
          nativeAsset: currency.nativeAsset,
          searchBy: ["displayText", "value"],
          paymentId: paymentId,
          precisionPayout: currency.precisionPayout,
          avgProcessingTime: currency.avgProcessingTime,
          payoutEnabled: currency.payoutEnabled,
          balance: getRoundedDownValue(balance, currency.originalName).replace(/,/g, ""),
          withdrawAllEnable: currency.withdrawAllEnable === undefined ? null : currency.withdrawAllEnable,
          networkList: currency.networkList
        });
      });
      var usdtCurrenciesRounded = result.reduce(function (memo, current) {
        if (TETHER_CHAINS_CURRENCIES.includes(current.value)) {
          memo.push(_objectSpread(_objectSpread({}, current), {}, {
            balance: getRoundedDownValue(current.balance.replace(/,/g, ""), CURRENCIES.USDT)
          }));
        }
        return memo;
      }, []);
      var usdtCurrency = usdtCurrenciesRounded.reduce(function (acc, prev) {
        acc.value = "USDT";
        acc.text = "USDT";
        acc.displayText = "Tether";
        acc.searchBy = ["displayText", "value"];
        acc.paymentId = prev.paymentId;
        acc.balance = add(acc.balance.replace(/,/g, ""), prev.balance.replace(/,/g, ""));
        acc.precisionPayout = prev.precisionPayout;
        acc.avgProcessingTime = prev.avgProcessingTime;
        acc.payoutEnabled = prev.payoutEnabled;
        acc.withdrawAllEnable = prev.withdrawAllEnable === undefined ? null : prev.withdrawAllEnable;
        acc.nativeAsset = prev.nativeAsset;
        acc.networkList = prev.networkList;
        return acc;
      }, {
        balance: "0"
      });
      var _iterator3 = _createForOfIteratorHelper(TETHER_CHAINS_CURRENCIES),
        _step3;
      try {
        var _loop5 = function _loop5() {
          var currency = _step3.value;
          var index = findIndexInArray(result, function (_ref32) {
            var value = _ref32.value;
            return value === currency;
          });
          if (index > -1) {
            result.splice(index, 1);
          }
        };
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop5();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      result.push(usdtCurrency);
      return result;
    };
  },
  isAlias: function isAlias(_, getters) {
    return function (currency1, currency2, exchangeId) {
      var key = "".concat(exchangeId, ":").concat(currency1);
      return getters.currencyToAliasMap[key] === currency2;
    };
  },
  getAliasCurrency: function getAliasCurrency(_, getters) {
    return function (exchangeId, currency) {
      var currencyToAliasMap = getters.currencyToAliasMap;
      var aliasKey = "".concat(exchangeId, ":").concat(currency === null || currency === void 0 ? void 0 : currency.toUpperCase());
      var aliasCurrency = currencyToAliasMap[aliasKey];
      return aliasCurrency ? formatCurrencyCasing(aliasCurrency) : formatCurrencyCasing(currency);
    };
  },
  currencyToAliasMap: function currencyToAliasMap() {
    var map = {};
    var _iterator4 = _createForOfIteratorHelper(config.state.aliases),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var item = _step4.value;
        var key = "".concat(item.exchangeId, ":").concat(item.currency);
        map[key] = item.alias;
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
    return map;
  },
  exchangeIdToAliasesMap: function exchangeIdToAliasesMap() {
    var e = config.state.aliases.reduce(function (memo, item) {
      var exchangeId = item.exchangeId;
      if (!item.alias) {
        return memo;
      }
      if (memo[exchangeId]) {
        memo[exchangeId].push(item);
      } else {
        memo[exchangeId] = [item];
      }
      return memo;
    }, {});
    return e;
  },
  aliasToCurrencyMap: function aliasToCurrencyMap() {
    var map = config.state.aliases.reduce(function (memo, _ref33) {
      var alias = _ref33.alias,
        currency = _ref33.currency,
        exchangeId = _ref33.exchangeId;
      var key = "".concat(exchangeId, ":").concat(alias);
      if (memo[key]) {
        memo[key].add(currency);
      } else {
        memo[key] = new Set([currency]);
      }
      return memo;
    }, {});
    return Object.entries(map).reduce(function (memo, _ref34) {
      var _ref35 = _slicedToArray(_ref34, 2),
        key = _ref35[0],
        value = _ref35[1];
      memo[key] = _toConsumableArray(value);
      return memo;
    }, {});
  },
  getMappedAccountType: function getMappedAccountType(_, getters) {
    return function (exchangeId, accountType) {
      var _getters$exchangeName = getters.exchangeNames,
        BINANCE_CUSTODY = _getters$exchangeName.BINANCE_CUSTODY,
        FIREBLOCKS = _getters$exchangeName.FIREBLOCKS,
        BEQUANT = _getters$exchangeName.BEQUANT,
        HITBTC = _getters$exchangeName.HITBTC,
        BINANCE = _getters$exchangeName.BINANCE,
        BITFINEX = _getters$exchangeName.BITFINEX,
        COPPER = _getters$exchangeName.COPPER,
        COPPER_DERIBIT = _getters$exchangeName.COPPER_DERIBIT,
        COPPER_BYBIT = _getters$exchangeName.COPPER_BYBIT,
        COPPER_GATE = _getters$exchangeName.COPPER_GATE,
        COPPER_OKX = _getters$exchangeName.COPPER_OKX,
        COPPER_BITGET = _getters$exchangeName.COPPER_BITGET;
      if (accountType === "unified-account") {
        return "Unified";
      }
      if ([BINANCE_CUSTODY, COPPER_DERIBIT, COPPER_BYBIT, COPPER_GATE, COPPER_OKX, COPPER_BITGET].includes(exchangeId)) {
        return "Off-Exchange Custody";
      }
      if ([COPPER, FIREBLOCKS].includes(exchangeId)) {
        return "Custody";
      }
      if (accountType === "spot") {
        return "Spot";
      }
      if ([BEQUANT, HITBTC].includes(exchangeId) && accountType.includes("margin-isolated") || exchangeId === BITFINEX && accountType === "margin-cross" || exchangeId === BINANCE && accountType === "cross_margin") {
        return "Spot Margin";
      }
      if (accountType === "portfolio_margin") {
        return "Portfolio Margin";
      }
      return "Derivatives";
    };
  },
  getCurrencyFullName: function getCurrencyFullName(_, __, ___, rootGetters) {
    return function (currency) {
      var _currencyMap$currency;
      var currencyMap = rootGetters["config/currencyMap"];
      return (_currencyMap$currency = currencyMap[currency]) === null || _currencyMap$currency === void 0 ? void 0 : _currencyMap$currency.fullName;
    };
  },
  getExchangeFullName: function getExchangeFullName(_, getters) {
    return function (exchangeId) {
      var _getters$exchangeFull;
      return (_getters$exchangeFull = getters.exchangeFullnames[exchangeId]) !== null && _getters$exchangeFull !== void 0 ? _getters$exchangeFull : exchangeId;
    };
  },
  dayToBalanceMap: function dayToBalanceMap(state) {
    var _useCurrency5 = useCurrency(),
      convertTo = _useCurrency5.convertTo;
    return Object.entries(state.balanceHistory).reduce(function (memo, _ref36) {
      var _ref37 = _slicedToArray(_ref36, 2),
        day = _ref37[0],
        balances = _ref37[1];
      var paramsCurrency = state.portfolioParams.accountCurrency && !Array.isArray(state.portfolioParams.accountCurrency) ? state.portfolioParams.accountCurrency : state.portfolioParams.currency;
      memo[day] = paramsCurrency ? balances[paramsCurrency] : balances[convertTo.value];
      return memo;
    }, {});
  },
  assetToAccountsMap: function assetToAccountsMap(_, getters) {
    var derivativesAssetToAccountsMap = getters.derivativesAssetToAccountsMap,
      spotAssetToAccountsMap = getters.spotAssetToAccountsMap;
    var result = {};
    for (var key in derivativesAssetToAccountsMap) {
      if (!Array.isArray(result[key])) {
        result[key] = [];
      }
      result[key] = result[key].concat(derivativesAssetToAccountsMap[key]);
    }
    for (var _key in spotAssetToAccountsMap) {
      if (!Array.isArray(result[_key])) {
        result[_key] = [];
      }
      result[_key] = result[_key].concat(spotAssetToAccountsMap[_key]);
    }
    return result;
  },
  assetToBalanceMap: function assetToBalanceMap(_, getters) {
    return getAssetToBalanceMap(getters.assetToAccountsMap);
  },
  assetToPositiveBalanceMap: function assetToPositiveBalanceMap(_, getters) {
    return getAssetToPositiveBalanceMap(getters.assetToAccountsMap);
  },
  derivativesCollateralMap: function derivativesCollateralMap(state) {
    var derivativesCollateral = state.derivativesCollateral;
    return derivativesCollateral.reduce(function (memo, item) {
      var apiKeyId = item.apiKeyId,
        currency = item.currency,
        accountType = item.accountType;
      var key = "".concat(apiKeyId, ":").concat(currency, ":").concat(accountType);
      memo[key] = item;
      return memo;
    }, {});
  },
  derivativesCollateralNonZero: function derivativesCollateralNonZero(state, getters, _, rootGetters) {
    var getApiKey = rootGetters["portfolio/getApiKey"];
    var exchangeFullnames = getters.exchangeFullnames,
      getCurrencyFullName = getters.getCurrencyFullName,
      getMappedAccountType = getters.getMappedAccountType,
      getAliasCurrency = getters.getAliasCurrency;
    var emptyConverted = Object.assign({}, ZERO_CONVERTED_BALANCES);
    var _useCurrency6 = useCurrency(),
      convertTo = _useCurrency6.convertTo;
    var data = state.derivativesCollateral.reduce(function (memo, derivative) {
      var _getApiKey3, _apiKey$name;
      var balance = derivative.balance || "0";
      var available = derivative.available || "0";
      if (isZero(balance) && isZero(available)) {
        return memo;
      }
      var exchangeFullName = exchangeFullnames[derivative.exchangeId];
      var currency = derivative.currency,
        exchangeId = derivative.exchangeId,
        apiKeyId = derivative.apiKeyId,
        accountType = derivative.accountType,
        marginMode = derivative.marginMode;
      var apiKey = (_getApiKey3 = getApiKey(apiKeyId)) !== null && _getApiKey3 !== void 0 ? _getApiKey3 : {};
      var bankAccount = apiKey.bankAccount,
        restrictions = apiKey.restrictions;
      var balanceConverted = derivative.balanceConverted || emptyConverted;
      var availableConverted = derivative.availableConverted || emptyConverted;
      var borrowed = derivative.borrowed || null;
      var borrowedConverted = derivative.borrowedConverted || emptyConverted;
      var netValue = derivative.netValue || null;
      var netValueConverted = derivative.netValueConverted || emptyConverted;
      var interest = derivative.interest || null;
      var interestConverted = derivative.interestConverted || emptyConverted;
      var availableToBorrow = derivative.availableToBorrow || null;
      var availableToBorrowConverted = derivative.availableToBorrowConverted || emptyConverted;
      var borrowUsageRate = derivative.borrowUsageRate || null;
      var formattedCurrency = getAliasCurrency(exchangeId, currency);
      var isInDebt = exchangeId === getters.exchangeNames.FTX && !restrictions.margin_enabled && isLessThan(balance, 0);
      var item = {
        apiKeyId: apiKeyId,
        accountType: accountType,
        formattedAccountType: getMappedAccountType(exchangeId, accountType),
        apiKeyName: (_apiKey$name = apiKey === null || apiKey === void 0 ? void 0 : apiKey.name) !== null && _apiKey$name !== void 0 ? _apiKey$name : '',
        exchangeFullName: exchangeFullName,
        exchangeId: exchangeId,
        currency: formattedCurrency,
        currencyFullName: getCurrencyFullName(formattedCurrency),
        balance: _defineProperty({}, formattedCurrency, balance),
        balanceConverted: _defineProperty({}, formattedCurrency, balanceConverted),
        available: _defineProperty({}, formattedCurrency, available),
        availableConverted: _defineProperty({}, formattedCurrency, availableConverted),
        bankAccount: bankAccount,
        borrowed: borrowed,
        borrowedConverted: borrowedConverted[convertTo.value],
        netValue: netValue,
        netValueConverted: netValueConverted[convertTo.value],
        interest: interest,
        interestConverted: interestConverted[convertTo.value],
        total: parseFloat(balance),
        totalConverted: balanceConverted[convertTo.value],
        availableToBorrow: availableToBorrow,
        availableToBorrowConverted: availableToBorrowConverted === null || availableToBorrowConverted === void 0 ? void 0 : availableToBorrowConverted[convertTo.value],
        borrowUsageRate: borrowUsageRate,
        isInDebt: isInDebt,
        marginMode: marginMode
      };
      memo.push(item);
      return memo;
    }, []);
    return data;
  },
  derivativesAssetToAccountsMap: function derivativesAssetToAccountsMap(state, getters, __, rootGetters) {
    var getApiKey = rootGetters["portfolio/getApiKey"];
    var _useCurrency7 = useCurrency(),
      convertTo = _useCurrency7.convertTo;
    var collateral = getters.derivativesCollateralNonZero.map(function (current) {
      var _getApiKey4, _current$balanceConve;
      var _ref38 = (_getApiKey4 = getApiKey(current.apiKeyId)) !== null && _getApiKey4 !== void 0 ? _getApiKey4 : {},
        apiKeyName = _ref38.name;
      return {
        exchangeId: current.exchangeId,
        apiKeyId: current.apiKeyId,
        apiKeyName: apiKeyName,
        accountType: current.accountType,
        balance: _defineProperty({}, current.currency, +current.balance[current.currency]),
        balanceConverted: +((_current$balanceConve = current.balanceConverted[current.currency]) === null || _current$balanceConve === void 0 ? void 0 : _current$balanceConve[convertTo.value])
      };
    });
    return collateral.reduce(function (memo, _ref39) {
      var balance = _ref39.balance,
        balanceConverted = _ref39.balanceConverted,
        exchangeId = _ref39.exchangeId,
        apiKeyId = _ref39.apiKeyId,
        apiKeyName = _ref39.apiKeyName,
        accountType = _ref39.accountType;
      for (var currency in balance) {
        var total = balance[currency];
        var currencyFormatted = formatCurrencyCasing(currency);
        var data = {
          exchangeId: exchangeId,
          apiKeyId: apiKeyId,
          apiKeyName: apiKeyName,
          accountType: accountType,
          total: +total,
          totalConverted: balanceConverted
        };
        memo[currencyFormatted] = memo[currencyFormatted] || [];
        memo[currencyFormatted].push(data);
      }
      return memo;
    }, {});
  },
  spotAssetToAccountsMap: function spotAssetToAccountsMap(_, getters, __, rootGetters) {
    var getApiKey = rootGetters["portfolio/getApiKey"];
    var _useCurrency8 = useCurrency(),
      convertTo = _useCurrency8.convertTo;
    return getters.balance.reduce(function (memo, _ref40) {
      var balance = _ref40.balance,
        balanceConverted = _ref40.balanceConverted,
        available = _ref40.available,
        availableConverted = _ref40.availableConverted,
        exchangeId = _ref40.exchangeId,
        apiKeyId = _ref40.apiKeyId;
      for (var asset in balance) {
        var _getApiKey5;
        var total = balance[asset];
        var _ref41 = (_getApiKey5 = getApiKey(apiKeyId)) !== null && _getApiKey5 !== void 0 ? _getApiKey5 : {},
          apiKeyName = _ref41.name;
        if (total) {
          var _memo$asset;
          var data = {
            exchangeId: exchangeId,
            apiKeyId: apiKeyId,
            apiKeyName: apiKeyName,
            accountType: "spot",
            available: available[asset],
            availableConverted: availableConverted[asset][convertTo.value],
            total: total.valueOf(),
            totalConverted: balanceConverted[asset][convertTo.value]
          };
          memo[asset] = (_memo$asset = memo[asset]) !== null && _memo$asset !== void 0 ? _memo$asset : [];
          memo[asset].push(data);
        }
      }
      return memo;
    }, {});
  },
  spotAssetToBalanceMap: function spotAssetToBalanceMap(_, getters) {
    return getAssetToBalanceMap(getters.spotAssetToAccountsMap);
  },
  exchangeToAccountsMap: function exchangeToAccountsMap(_, getters, __, rootGetters) {
    var getApiKey = rootGetters["portfolio/getApiKey"];
    var _useCurrency9 = useCurrency(),
      convertTo = _useCurrency9.convertTo;
    return getters.balance.reduce(function (memo, _ref42) {
      var balance = _ref42.balance,
        totalConverted = _ref42.totalConverted,
        exchangeId = _ref42.exchangeId,
        apiKeyId = _ref42.apiKeyId;
      for (var asset in balance) {
        var _getApiKey6, _memo$exchangeId;
        var total = balance[asset];
        var _ref43 = (_getApiKey6 = getApiKey(apiKeyId)) !== null && _getApiKey6 !== void 0 ? _getApiKey6 : {},
          apiKeyName = _ref43.name;
        var data = {
          currency: formatCurrencyCasing(asset),
          apiKeyId: apiKeyId,
          apiKeyName: apiKeyName,
          total: total.valueOf(),
          totalConverted: totalConverted[convertTo.value]
        };
        memo[exchangeId] = (_memo$exchangeId = memo[exchangeId]) !== null && _memo$exchangeId !== void 0 ? _memo$exchangeId : [];
        memo[exchangeId].push(data);
      }
      return memo;
    }, {});
  },
  exchangeToBalanceMap: function exchangeToBalanceMap(_, getters) {
    return Object.entries(getters.exchangeToAccountsMap).reduce(function (memo, _ref44) {
      var _ref45 = _slicedToArray(_ref44, 2),
        exchangeId = _ref45[0],
        accounts = _ref45[1];
      var data = accounts.reduce(function (memo, _ref46) {
        var totalConverted = _ref46.totalConverted,
          apiKeyId = _ref46.apiKeyId;
        if (memo.apiKeyId !== apiKeyId) {
          memo.totalConverted = add(totalConverted, memo.totalConverted);
        }
        memo.apiKeyId = apiKeyId;
        return memo;
      }, {
        totalConverted: "0",
        apiKeyId: ""
      });
      memo[exchangeId] = data;
      return memo;
    }, {});
  },
  getCurrencyPrecision: function getCurrencyPrecision(_, __, ___, rootGetters) {
    return function (currency) {
      var _currencyObj$precisio;
      if (!currency) {
        return config.state.uiFormatters.LONG_PRECISION_MANTISSA;
      }
      var finalCurrency = currency;
      if (USDTs.has(finalCurrency)) {
        finalCurrency = "USDT";
      }
      var currencyMap = rootGetters["config/currencyMap"];
      var currencyObj = currencyMap[finalCurrency];
      return (_currencyObj$precisio = currencyObj === null || currencyObj === void 0 ? void 0 : currencyObj.precision) !== null && _currencyObj$precisio !== void 0 ? _currencyObj$precisio : config.state.uiFormatters.LONG_PRECISION_MANTISSA;
    };
  },
  exchangeFullnames: function exchangeFullnames() {
    return Object.keys(config.state.exchanges).reduce(function (memo, key) {
      memo[config.state.exchanges[key].exchangeId] = config.state.exchanges[key].fullName;
      return memo;
    }, {});
  },
  exchangeNames: function exchangeNames() {
    return Object.entries(config.state.exchanges).reduce(function (memo, _ref47) {
      var _ref48 = _slicedToArray(_ref47, 2),
        key = _ref48[0],
        value = _ref48[1];
      memo[key] = value.exchangeId;
      return memo;
    }, {});
  },
  getPropertyValue: function getPropertyValue(_, getters) {
    return function (value) {
      var maxValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var rawCurrency = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      if (!value) {
        return 0;
      }
      var _useCurrency10 = useCurrency(),
        convertTo = _useCurrency10.convertTo;
      var mantissa = getters.getCurrencyPrecision(rawCurrency !== null && rawCurrency !== void 0 ? rawCurrency : convertTo.value);
      var NUMBER_OPTIONS = {
        rule: config.state.uiFormatters.ROUNDING_RULES.CUSTOM_PRECISION,
        mantissa: mantissa,
        roundDown: true,
        noSeparator: true
      };
      var result = numbro(value, rawCurrency !== null && rawCurrency !== void 0 ? rawCurrency : convertTo.value, NUMBER_OPTIONS);
      if (maxValue !== null) {
        return isGreaterThanOrEqualTo(result, maxValue) ? maxValue : result;
      }
      return result;
    };
  },
  totalAssets: function totalAssets(_, getters) {
    var _useCurrency11 = useCurrency(),
      convertTo = _useCurrency11.convertTo;
    var totalEarnings = earn.state.depositsTotal[convertTo.value];
    var result = add(getters.totalBalance, totalEarnings, getters.derivativesTotalBalance);
    return getters.getPropertyValue(result);
  },
  todayDate: function todayDate() {
    return dayjs().utc().format(config.state.uiFormatters.DATE_FORMAT);
  },
  yesterdayDate: function yesterdayDate() {
    return dayjs().utc().subtract(STATISTICS_PERIOD, STATISTICS_PERIOD_UNIT).format(config.state.uiFormatters.DATE_FORMAT);
  }
};
var mutations = {
  setRoute: function setRoute(state, route) {
    state.route = route;
  },
  resetStore: function resetStore(state) {
    Object.assign(state, getDefaultState());
  },
  setPNLHistoryRealised24h: function setPNLHistoryRealised24h(state, data) {
    state.pnlHistoryRealised24h = data;
  },
  setPNLHistoryRealised: function setPNLHistoryRealised(state, data) {
    state.pnlHistoryRealised = data;
  },
  setPNLHistoryUnrealised: function setPNLHistoryUnrealised(state, data) {
    state.pnlHistoryUnrealised = data;
  },
  setDerivatives: function setDerivatives(state, derivatives) {
    state.derivatives = derivatives;
  },
  setDerivativesCollateral: function setDerivativesCollateral(state, data) {
    state.derivativesCollateral = data;
  },
  setDerivativesTotalBalance: function setDerivativesTotalBalance(state, derivativesTotalBalance) {
    state.derivativesTotalBalance = derivativesTotalBalance;
  },
  setBalanceHistory: function setBalanceHistory(state, data) {
    state.balanceHistory = data;
  },
  setSpotBalance: function setSpotBalance(state, data) {
    state.spotBalance = data;
  },
  setRawSpotBalance: function setRawSpotBalance(state, rawSpotBalance) {
    state.rawSpotBalance = rawSpotBalance;
  },
  setTotalBalance: function setTotalBalance(state, totalBalance) {
    state.totalBalance = totalBalance;
  },
  setPortfolioParams: function setPortfolioParams(state, portfolioParams) {
    state.portfolioParams = Object.keys(portfolioParams).length === 0 ? {} : _objectSpread(_objectSpread({}, state.portfolioParams), portfolioParams);
  },
  setRestricted: function setRestricted(state, value) {
    state.isRestricted = value;
  },
  setIsBalanceHistoryLoading: function setIsBalanceHistoryLoading(state, value) {
    state.isBalanceHistoryLoading = value;
  },
  setIsSpotBalanceLoading: function setIsSpotBalanceLoading(state, value) {
    state.isSpotBalanceLoading = value;
  },
  setIsDerivativeBalanceLoading: function setIsDerivativeBalanceLoading(state, value) {
    state.isDerivativeBalanceLoading = value;
  }
};
var store = createStore({
  modules: {
    withdraw: withdraw,
    whitelist: whitelist,
    reports: reports,
    customerApiKeys: customerApiKeys,
    trading: trading,
    openOrdersAndPositions: openOrdersAndPositions,
    earn: earn,
    risk: risk,
    riskquant: riskquant,
    notifications: notifications,
    loans: loans,
    fees: fees,
    portfolio: portfolio,
    apiKeys: apiKeys,
    auth: auth,
    transfer: transfer,
    transactions: transactions,
    config: config,
    trades: trades,
    defi: defi,
    newPortfolio: newPortfolio,
    agreements: agreements,
    pnl: pnl,
    detelio: detelio
  },
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});
export default store;